import { v4 } from "uuid";
import { getCookie, CookieTypes, setCookie, expireCookie } from "./helpers/cookie-tools.js";
const initUnicClientBrowserCode = () => {
  if (!getCookie(CookieTypes.unicBrowserCode)) {
    const deviceId = v4();
    const { hostname } = window.location;
    setCookie(CookieTypes.unicBrowserCode, deviceId, { expires: expireCookie(), domain: hostname });
  }
};
const getUnicBrowserCode = () => {
  initUnicClientBrowserCode();
  return getCookie(CookieTypes.unicBrowserCode);
};
export {
  getUnicBrowserCode,
  initUnicClientBrowserCode
};
